import { render, staticRenderFns } from "./ObjectGroupMembership.vue?vue&type=template&id=ef3763e2&"
import script from "./ObjectGroupMembership.vue?vue&type=script&lang=js&"
export * from "./ObjectGroupMembership.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports